module.exports = __webpack_public_path__ + "71041bceeed2a1d2f8e5ca67b88f71b1.svg";